










































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { PaginationMixin } from '@/components/base/pagination.mixin';
import BasePagination from '@/components/base/BasePagination.vue';
import BaseLoading from '@/components/base/BaseLoading.vue';
import { mixins } from 'vue-class-component';
import { RootState } from '@/store/store';
import SortableTableHeader from '@/components/SortableTableHeader.vue';
import BaseTable from '@/components/BaseTable.vue';
import { AuditLog } from '@/store/modules/audit-log/types/audit-log.types';
import dayjs from 'dayjs';
import TableActionDropdown from '@/components/TableActionDropdown.vue';
import AuditLogModal from './AuditLogModal.vue';
import { moneyParser } from '@/utils/parser.util';
import { isDifferent, isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import { ToastProgrammatic as Toast } from 'buefy';
import Receipt from '../../Order/components/Receipt.vue';
import { PaymentStatusTypes } from '../../../store/types/general.types';
import { downloadReceiptPDF } from '@/Export/ReceiptPDFGenerator';
import {
  BPointV3TxnResp,
  BPointV5TxnResp
} from '@/store/modules/order/order.types';

@Component({
  components: {
    BaseTable,
    SortableTableHeader,
    BasePagination,
    BaseLoading,
    TableActionDropdown,
    Receipt
  }
})
export default class AuditLogList extends mixins(PaginationMixin) {
  sortHeaders = [
    { placeholder: 'Order No.', sortColumn: 'orderId', sort: true },
    {
      placeholder: 'Customer',
      sortColumn: 'username',
      sort: true
    },
    { placeholder: 'Product', sortColumn: 'productName', sort: true },
    { placeholder: 'Price', sortColumn: 'productPrice', sort: true },
    { placeholder: 'GST', sort: false },
    { placeholder: 'Total Price', sortColumn: 'totalPrice', sort: true },
    { placeholder: 'Date', sortColumn: 'startDate', sort: true },
    { placeholder: 'Status', sort: false }
  ];
  @Prop() public items!: AuditLog[];
  @Prop(Number) public currentPage!: number;
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;
  @Prop(String) public sortColumn!: string;
  @Prop(String) public sortOrder!: 'ASC' | 'DESC';
  @Prop() public isDownload!: boolean | null;
  isDownloadingReceipt = false;
  receipt: AuditLog | undefined;

  @State(({ auditLog }: RootState) => auditLog.apiState.getAuditLogs.success)
  public getAuditLogSuccess!: boolean;

  public getTransactionStatus(paymentStatus: PaymentStatusTypes) {
    return paymentStatus === PaymentStatusTypes.SUCCESS
      ? 'Successful'
      : paymentStatus === PaymentStatusTypes.FAILED
      ? 'Failed'
      : 'Pending';
  }

  public getSortOrderOfColumn(name: string) {
    if (this.sortColumn === name) {
      return this.sortOrder;
    }
    return 'ASC';
  }

  public getAuditLog(auditLogId: number) {
    this.receipt = this.items.find((res) => res.id === auditLogId);
    setTimeout(() => {
      this.handleDownloadPdf();
    }, 800);
    return;
  }

  normalizeTxnResp(resp: BPointV3TxnResp | BPointV5TxnResp | undefined) {
    if (!resp) {
      return {
        cardHolderName: 'N/A',
        maskedCardNumber: 'N/A',
        receiptNumber: '-',
        merchantNumber: '-'
      };
    }

    if ('CardDetails' in resp) {
      return {
        cardHolderName: resp.CardDetails?.CardHolderName,
        maskedCardNumber: resp.CardDetails?.MaskedCardNumber,
        receiptNumber: resp.ReceiptNumber,
        merchantNumber: resp.MerchantNumber
      };
    }

    return {
      cardHolderName: 'N/A',
      maskedCardNumber: resp.paymentMethod?.card.number || 'N/A',
      receiptNumber: resp.receiptNumber || '-',
      merchantNumber: resp.merchantNumber || '-'
    };
  }

  public getReceipt() {
    const txnResp = this.normalizeTxnResp(this.receipt?.txnResp);

    let billingAddress = 'N/A';
    if (this.receipt && this.receipt.transaction_status.billingAddress) {
      const address = this.receipt.transaction_status.billingAddress;
      const streetAddress = address.streetAddress || '';
      const city = address.city || '';
      const country = address.country || '';
      if (country) {
        billingAddress = `${streetAddress} ${city} ${country}`;
      }
    }

    let productAmount: number | 'N/A' = 'N/A';
    let gstAmount: number | 'N/A' = 'N/A';
    let totalAmount: number | 'N/A' = 'N/A';
    let gstPercentage: string = 'N/A';
    if (this.receipt?.payment_amount) {
      totalAmount = +this.receipt?.payment_amount;
      gstAmount = +this.receipt?.gst_amount;
      productAmount = this.receipt?.payment_amount - this.receipt?.gst_amount;
      gstPercentage = `(${Math.round(
        (totalAmount / productAmount - 1) * 100
      )}%)`;
    }

    return {
      orderNumber: this.receipt?.order_number || 'N/A',
      updatedAt: this.receipt?.started_at
        ? dayjs(this.receipt?.started_at).format('D MMM YYYY, hh:mm A')
        : 'N/A',
      paymentCurrency: this.receipt?.payment_currency || 'N/A',
      productName: this.receipt?.product,
      price:
        productAmount > 0 && productAmount !== 'N/A'
          ? moneyParser({ value: productAmount })
          : moneyParser({ value: 0 }),
      gst:
        gstAmount > 0 && gstAmount !== 'N/A'
          ? moneyParser({ value: gstAmount })
          : 'N/A',
      amount:
        totalAmount > 0 && totalAmount !== 'N/A'
          ? moneyParser({ value: totalAmount })
          : moneyParser({ value: 0 }),
      cardHolderName: txnResp.cardHolderName,
      cardNumber: txnResp.maskedCardNumber,
      receiptNumber: txnResp.receiptNumber,
      merchantNumber: txnResp.merchantNumber,
      billingAddress,
      gstPercentage
    };
  }

  public handleDownloadPdf() {
    this.isDownloadingReceipt = true;

    setTimeout(() => {
      try {
        const transaction = document.getElementById('downloadReceipt');
        if (!transaction) {
          Toast.open({
            queue: true,
            type: 'is-danger',
            position: 'is-top',
            message: `Could not find the receipt element.`
          });

          this.isDownloadingReceipt = false;
          return;
        }
        const receipt = this.getReceipt();
        downloadReceiptPDF(receipt);

        // Show success toast only once after everything is complete
        Toast.open({
          queue: true,
          type: 'is-success',
          position: 'is-top',
          message: 'PDF generated successfully.'
        });
      } catch (error) {
        Toast.open({
          queue: true,
          type: 'is-danger',
          position: 'is-top',
          message: `Error generating PDF. ${error}`
        });
      } finally {
        this.isDownloadingReceipt = false;
      }
    }, 500);
  }

  public onClickHeaderColumn(columnName: string) {
    if (this.sortColumn === columnName) {
      return this.$emit('sort', {
        sortColumn: columnName,
        sortOrder: this.sortOrder === 'ASC' ? 'DESC' : 'ASC'
      });
    }
    this.$emit('sort', {
      sortColumn: columnName,
      sortOrder: 'DESC'
    });
  }

  public formatDate(date: Date) {
    const result = dayjs(date).format('D MMMM YYYY');

    return result === 'Invalid Date' ? '-' : result;
  }

  public async handleOpenAuditLog(auditLogId: number, items: AuditLog[]) {
    this.$buefy.modal.open({
      parent: this,
      component: AuditLogModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        auditLogId,
        items
      }
    });
  }

  getProductPrice(auditLog: AuditLog): string {
    const productPrice = auditLog.payment_amount - auditLog.gst_amount;
    return moneyParser({
      currency: auditLog.payment_currency,
      value: productPrice
    });
  }

  getGstAmount(auditLog: AuditLog): string {
    const gst = auditLog.gst_amount;
    if (!gst) return 'N/A';
    return moneyParser({
      currency: auditLog.payment_currency,
      value: gst
    });
  }

  getTotalPrice(auditLog: AuditLog): string {
    return moneyParser({
      currency: auditLog.payment_currency,
      value: auditLog.payment_amount
    });
  }

  @isDifferent
  @isTruthy
  @Watch('isDownloadingReceipt')
  public handleDownloadReceipt() {
    Toast.open({
      queue: true,
      type: 'is-dark',
      position: 'is-top',
      message: `Downloading receipt...`
    });
  }
}
